const state = {
  searchForm: {}
}

const mutations = {
  SET_SEARCH_FORM(state, searchForm) {
    console.log(searchForm)
    state.searchForm = searchForm
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
